export enum FundTypeClass {
    Equity = "EquityFund",
    MoneyMarket = "MoneyMarketFund",
    Pension = "PensionFund",
    RealEstate = "RealEstateFund",
    Mixed = "MixedFund"
    // currently available but not in middleware
    // Umbrella = "UmbrellaFund",
    // Miscellaneous = "MiscellaneousFunds",
    // Commodity = "CommodityFund"
}
